import {
  FaBasketballBall,
  FaBicycle,
  FaCalendarAlt,
  FaClock,
  FaEnvelope,
  FaFootballBall,
  FaFutbol,
  FaGolfBall,
  FaHandshake,
  FaHockeyPuck,
  FaImages,
  FaInfoCircle,
  FaMountain,
  FaNewspaper,
  FaRunning,
  FaSkiing,
  FaSwimmer,
  FaTableTennis,
  FaTrophy,
  FaUsers,
  FaVolleyballBall,
  FaTiktok,
} from "react-icons/fa";

import {
  GiBoxingGlove,
  GiFencer,
  GiHighKick,
  GiHorseHead,
  GiKimono,
  GiTennisRacket,
} from "react-icons/gi";

import {
  MdOutlineSportsHandball,
  MdOutlineSportsMartialArts,
  MdRowing,
  MdSportsKabaddi,
} from "react-icons/md";

export const FALLBACK_LOGO = "/img/no-image.jpg";
export const FALLBACK_AVATAR = "/img/user_avatar.jpg";

export const DEFAULT_SETTINGS = {
  nom_club: "MonAppliClub",
  shortname_club: "Club",
  logo_club: "",
  adresse_club: "",
  tel_club: "",
  mail_club: "",
  facebook_club: "",
  instagram_club: "",
  tiktok_club: "",
  discipline_icone: "GiKimono",

  display_boutique: true,
  display_chat: true,
  display_news: true,
  display_galerie: true,
  display_lexique: true,
  display_techniques: true,
  display_appels: true,
  display_todolist: true,
  display_coaching: true,
  display_heures_enseignants: true,
  display_inventaire: true,
  display_chat_admin: true,
  display_messages_admin: true,
};

export const CLUB_SECTIONS = [
  {
    label: "À propos",
    targetId: "about",
    icon: FaInfoCircle,
  },
  {
    label: "Disciplines",
    targetId: "disciplines",
    icon: MdOutlineSportsMartialArts,
  },
  {
    label: "Groupes & Horaires",
    targetId: "cours",
    icon: FaClock,
  },
  {
    label: "Les équipes",
    targetId: "equipes",
    icon: FaUsers,
  },
  {
    label: "Prochaines dates",
    targetId: "dates",
    icon: FaCalendarAlt,
  },
  {
    label: "Dernières actualités",
    targetId: "actualites",
    icon: FaNewspaper,
  },
  {
    label: "Palmarès",
    targetId: "palmares",
    icon: FaTrophy,
  },
  {
    label: "Albums Photo",
    targetId: "galerie",
    icon: FaImages,
  },
  {
    label: "Nos partenaires",
    targetId: "partenaires",
    icon: FaHandshake,
  },
  {
    label: "Contact",
    targetId: "contact",
    icon: FaEnvelope,
  },
];

export const SPORT_ICONS = {
  FaFutbol,
  FaFootballBall,
  FaTableTennis,
  FaBicycle,
  FaRunning,
  FaSwimmer,
  FaBasketballBall,
  MdOutlineSportsHandball,
  GiKimono,
  GiFencer,
  GiTennisRacket,
  GiBoxingGlove,
  FaVolleyballBall,
  GiHorseHead,
  FaGolfBall,
  FaHockeyPuck,
  GiHighKick,
  FaMountain,
  MdRowing,
  FaSkiing,
  MdOutlineSportsMartialArts,
  MdSportsKabaddi,
};